var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreenOn = function SvgFullscreenOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.51 12.782.708.708L5.707 19H11v1H4v-7h1v5.291l5.51-5.509zM20 4v7h-1V5.707l-5.51 5.51-.708-.707L18.292 5H13V4h7z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgFullscreenOn;